import styled from '@emotion/styled'

export const Input = styled.input`
  appearance: none !important;

  width: 100%;
  border: 2px solid
    ${p => (p.error ? p.theme.colors.red : p.theme.colors.gray[3])};
  border-radius: ${p => p.theme.space[2]};
  padding: ${p => p.theme.space[4]};
  outline: none;
  background: ${p => p.theme.colors.white};
  line-height: ${p => p.theme.lineHeights.input};

  &::placeholder {
    color: ${p => p.theme.colors.gray[4]};
  }
`

export const Error = styled.p`
  color: ${p => p.theme.colors.error};
  font-size: ${p => p.theme.fontSizes[0]};
`
